import { error } from '../app/logger.js';
import { services } from '../app/services.js';
import { PipeableObject } from '../base/pipeable/pipeable_object.js';
import { LocationBaseMixin } from '../data/location_base_mixin.js';
import { LocationDetails } from './location_details.js';
import { Reviews } from './reviews.js';

/**
 * Represents a single location connected to data source.
 */
class Location extends LocationBaseMixin(PipeableObject) {
  constructor(...args) {
    super(...args);
    this.addReceiver('type', () => this.typeChanged());
  }

  load() {
    return Promise.resolve(this.#details.load()).then(() => this);
  }

  loadIfNeeded() {
    return Promise.resolve(this.#details.loadIfNeeded()).then(() => this);
  }

  // Area
  getArea() {
    if (!this.#areaPromise) {
      this.#areaPromise = services.location.getLocationArea(this.id);
    }
    return this.#areaPromise;
  }

  // Availability
  async reloadAvailability() {
    let data = await services.location.getAvailability(this.id);
    this.setAvailability(data);
  }

  setAvailability(data) {
    this.setProperty('availability', data);
  }

  // History
  async reloadHistory() {
    let data = await services.location.getLocationHistory(this.id);
    this.setProperty('history', data);
  }

  // Reviews
  addReview(reviewData) {
    this.reviews.insert(
      Object.assign({ canEdit: true, canDelete: true }, reviewData)
    );
    return services.location.addReview(reviewData);
  }

  changeReview(reviewData) {
    let review = this.reviews.findBy(reviewData);
    if (!review) {
      error(`[data] no ${reviewData.id} review found`);
      return null;
    }
    review.merge(reviewData);
    return services.location.changeReview(reviewData);
  }

  deleteReview(reviewData) {
    this.reviews.remove(reviewData);
    return services.location.deleteReview(reviewData.id);
  }

  static dataDeps = {
    fullDescription: ['name', 'description', 'type', 'rels'],
    googleMapsUrl: ['google_id', 'lat', 'lng'],
    position: ['lat', 'lng'],
    typeName: ['type', 'subtype'],
  };

  static Reviews = Reviews;

  get #details() {
    if (!this.#detailsCache) {
      this.#detailsCache = new LocationDetails(this);
    }
    return this.#detailsCache;
  }

  #areaPromise;
  #detailsCache;
}

export { Location };
